<div class="inputcontainer {{container_class}}">

	<label *ngIf="!hideLabel">{{ label }}</label> <br *ngIf="!hideLabel" />
	<input type="text" [(ngModel)]="ref_object[property]" placeholder="" 
		   class="ecertnl_input input" 
		   [class.wijzigbaar]="wijzigbaar"
		   [disabled]="disabled"/>
</div>